import './style.css';
import AutoControlForm from './components/AutoControlForm';

function App() {
  return (
    <div className="App">
      <AutoControlForm />
    </div>
  );
}

export default App;